import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-washing-machine-drum-repair", label: "LG Washing Machine Drum Repair" },
];

const LGWashingMachineNoiseProblem = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Noise Problem Repair in Bangalore"
      description="LG washing machine noise problem repair in Bangalore for loud spinning, bearing damage, drum imbalance, and vibration issues."
      keywords="lg washing machine noise problem, lg washer vibration repair, lg drum noise bangalore"
      path="/lg-washing-machine-noise-problem"
      bannerTitle="LG Washing Machine Noise Problem"
      intro={<>If your LG washing machine makes <span style={{ fontWeight: 'bold' }}>unusual noise</span> during wash or spin cycles, our Bangalore repair team can inspect the drum, bearings, motor, suspension parts, and mounting system to find the cause and reduce the noise.</>}
      highlights={[
        "Inspection for loud spin-cycle noise",
        "Bearing, drum, and suspension checks",
        "Vibration and balancing diagnosis",
        "Repair support for repeated noise complaints",
      ]}
      issues={[
        "Grinding or rattling sound",
        "Loud spinning noise",
        "Excess vibration during wash",
        "Drum imbalance symptoms",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineNoiseProblem;
